<template>
	<!-- 器械百科 -->
	<div class="instrument-index">
		<!-- 搜索 -->
		<div class="search">
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="搜索内容" @focus="goSearch">
			</div>
		</div>	
		<!-- 种类 -->
		<div class="kinds">
			<div class="head"  @click="spreadMoreKind">
				<h3>器械种类</h3>
				<van-icon :name="spread?'arrow-down':'arrow'"/>
				
			</div>
			<transition name="spread">
				<div class="content">
					<template v-for="(item,index) in classessList">
						<span class="line-clamp-1" @click="skipClassify(item)" :key="item.id" v-if="spread?index<classessList.length:index<=5">{{item.name}}</span>
					</template>
				</div>
			</transition>
		</div>
		<!-- 推荐的器械品牌 -->
		<div class="recommendBrand">
			<div class="head">
				<h3>推荐品牌</h3>
			</div>
			<div class="content">
				<div class="imgWrap" v-for="(item) in recommendBrands" @click="skipBrand(item)" :key="item.id">
					<img :src="item.banner" alt="">
					<div class="name">{{item.abbreviation}}</div>
				</div>
			</div>			
		</div>
		<!-- 品牌列表 -->
		<div class="brandList">
			<div class="head">
				<h3>器械品牌</h3>
			</div>
			<van-index-bar>
				<div v-for="(item,index) in brandsList" :key="index">
				  <van-index-anchor :index="index" />
				  <div class="brand-item" v-for="(val) in item" @click="skipBrand(val)" :key="val.id">
				  		<img :src="val.banner" alt="">
				  		<van-cell :title="val.name"/>
				  </div>				
				</div>
			</van-index-bar>
		</div>
	</div>
</template>
<script>
	import {InstrumentClassess,InstrumentBrands} from "../../config/interface.js"
	export default{
		data(){
			return{
				classessList:[],     //种类列表
				recommendBrands:[],   //推荐品牌
				brandsList:[],        //品牌列表
				spread:false,         //展开
			}
		},
		mounted(){
			this.getClassess();
			this.getBrands(0);
			this.getBrands(1);
			//微信浏览器  请求jsdk
			if(common.is_weixin()){
				common.moduleDetails(5);
			}
		},
		methods:{
			//跳转搜索
			goSearch(){
				this.$router.push({
					path:'/instrument/search'
				})
			},
			//器械种类
			getClassess(){
				const url=InstrumentClassess;
				const method='POST';
				let params={

				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.classessList=data;
					}
				})
			},
			//器械品牌
			getBrands(type){
				const url=InstrumentBrands;
				const method='POST';
				let params={
					recommend:type    //为1为推荐品牌 否则返回品牌列表
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						type==1?this.recommendBrands=data:this.brandsList=data;
					}
				})
			},
			//展开更多种类
			spreadMoreKind(){
				this.spread=!this.spread;
			},
			//跳转品牌
			skipBrand(item){
				console.log(item);
				this.$router.push({
					path:'/instrument/brand',
					query:{
						id:item.id,
						brandImg:item.banner
					}
				})
			},
			//跳转种类
			skipClassify(item){
				this.$router.push({
					path:'/instrument/classify/'+item.id,
					query:{
						title:item.name
					}
				})	
			}
		}
	}
</script>
<style lang="scss">
	.instrument-index{
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.location{
				color:#666;
				font-size:16px;
				margin-right:6px;
				span{
					margin-right:5px;
				}
			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:32px;
				padding:0 20px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
		}
		/*种类*/
		.kinds{
			padding:0 12px;
			.content{
				@include flex(row);
				flex-wrap: wrap;
				span{
					width:31%;
					height:36px;
					padding:0 5px;
					box-sizing: border-box;
					line-height:36px;
					text-align:center;
					border: 1px solid #D3D3D3;
					border-radius: 2px;
					font-size: 14px;
					color: #7E7E7E;
					letter-spacing: 0.49px;
					margin:0 1% 10px;
				}
			}
		}
		/*推荐的器械品牌*/
		.recommendBrand{
			padding:0 12px;
			.content{
				@include flex(row);
				flex-wrap:wrap;
				.imgWrap{
					position:relative;
					margin-left:5px;
					margin-bottom:10px;
				}
				img{
					width:110px;
				}
				.name{
					width:100%;
					height:20px;
					line-height:20px;
					background: #F1F2F4;
					font-size: 12px;
					color: #090909;
					letter-spacing: 0.42px;
					text-align: center;
				}
			}
		}
		.head{
			height:50px;
			@include flex(row);
			justify-content:space-between;
			align-items: center;
			h3{
				font-size: 17px;
				color: #090909;
				letter-spacing: 0.6px;
			}
			.van-icon{
				color:#999;
				font-size:16px;
			}
		}
		.brandList{
			h3{
				padding-left:12px;
			}
			.van-index-anchor{
				font-size: 17px;
				color: #090909;
				background: #F1F2F4;
				box-shadow: 0 0 0 0 #CECECE, 0 0 0 0 #CECECE;
			}
			.brand-item{
				height:68px;
				align-items:center;
				padding-left: 12px;
				@include flex(row);
				font-size: 14px;
				color: #090909;
				letter-spacing: 0.49px;
				img{
					height:40px;
					border-radius:50%;
				}
			}
		}
		.spread-enter-active, .spread-leave-active {
			transition: opacity .5s;
		}
		.spread-enter, .spread-leave-to /* .fade-leave-active below version 2.1.8 */ {
			opacity: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Instrument/index.vue